module.exports = __webpack_public_path__ + "img/t2-i4.cd9bb235.svg";